import { toDecimalString } from "../../../../../shared/utils/numbers";

const formaterNumberCell = (value,precision) => value < 0 ? `(${toDecimalString(value*-1,precision)})` : (value>0 ? toDecimalString(value,precision) : '-');
const mayorCien = (value) => value > 0 ? '>100' : '(>100)';

export const subTitlesTableTendVeh = [
    {label:'', colIni:0, colFin:1},
    {label:'SUCURSAL', colIni:2, colFin:11},
    {label:'', colIni:12, colFin:12},
    {label:'FILIAL', colIni:13, colFin:19},
    {label:'', colIni:20, colFin:20},
    {label:'UTE_EXTRANJERA', colIni:21, colFin:27},
    {label:'', colIni:28, colFin:28},
    {label:'ELECNOR_MATRIZ', colIni:29, colFin:38},
    {label:'', colIni:39, colFin:39},
    {label:'TOTAL', colIni:40, colFin:45}
]

export const columnsTableTendVeh = [
    {
      field: 'idCentro',
      name: 'Centro',
      sortable: true,
      'data-test-subj': 'centro fixed',
      render: (data) =>{
        return (
            <span>{ ((data.idPais!=='@@' && data.idPais!=='A@') ? (data.idPais==='00' ? `NACIONAL` : `INTERNACIONAL`) : `${data.idCentro} - ${data.centro}`)}</span>
      )},
      width:'400px'
    },
    {
        name: '',
        'data-test-subj': 'spaceCell fixedSpace',
        render: () => null,
        width:'5px'
    },
    {
        field: 'facT_SUC',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_SUC',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_SUC',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_SUC',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_SUC)>100 ? mayorCien(data.margen_SUC)  : formaterNumberCell(data.margen_SUC,1)}</span>),
        width:'100px'
    },
    {
        field: 'cpoS_SUC',
        name: 'C.POS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cpoS_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'cgraleS_SUC',
        name: 'G.GRALES',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cgraleS_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'baI_SUC',
        name: 'BAI FISCAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.baI_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'tasA_IS_SUC',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_SUC,1)}</span>),
        width:'100px'
    },
    {
        field: 'impsoC_SUC',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_SUC,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_SUC',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_SUC,0)}</span>),
        width:'110px'
    },
//11

    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },


    {
        field: 'facT_FIL',
        name: 'FACT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_FIL,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_FIL',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_FIL,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_FIL',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_FIL,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_FIL',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_FIL)>100 ? mayorCien(data.margen_FIL) : formaterNumberCell(data.margen_FIL,1)}</span>),
        width:'100px'
    },
    {
        field: 'tasA_IS_FIL',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_FIL,1)}</span>),
        width:'100px'
    },
    {
        field: 'impsoC_FIL',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_FIL,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_FIL',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_FIL,0)}</span>),
        width:'110px'
    },
//19
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },

    {
        field: 'facT_UTE',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_UTE,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_UTE',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_UTE,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_UTE',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_UTE,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_UTE',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_UTE)>100 ? mayorCien(data.margen_UTE) : formaterNumberCell(data.margen_UTE,1)}</span>),
        width:'100px'
    },
    {
        field: 'tasA_IS_UTE',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_UTE,1)}</span>),
        width:'100px'
    },
    {
        field: 'impsoC_UTE',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_UTE,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_UTE',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_UTE,0)}</span>),
        width:'110px'
    },
//27
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },

    {
        field: 'facT_ELEC',
        name: 'FACT',
        sortable: false,
        'data-test-subj': 'firstNameCell',
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.facT_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'proD_ELEC',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.proD_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'apoR_ELEC',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apoR_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'margen_ELEC',
        name: '%MARGEN',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{Math.abs(data.margen_ELEC)>100 ? mayorCien(data.margen_ELEC) : formaterNumberCell(data.margen_ELEC,1)}</span>),
        width:'100px'
    },
    {
        field: 'cpoS_ELEC',
        name: 'C.POS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cpoS_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'cgraleS_ELEC',
        name: 'G.GRALES',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.cgraleS_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'baI_ELEC',
        name: 'BAI FISCAL',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.baI_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'tasA_IS_ELEC',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS_ELEC,1)}</span>),
        width:'100px'
    },
    {
        field: 'impsoC_ELEC',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoC_ELEC,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdI_ELEC',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdI_ELEC,0)}</span>),
        width:'110px'
    },
//38
    {
        name: 'S',
        'data-test-subj': 'spaceCell',
        render: () => null,
        width:'10px'
    },

    {
        field: 'fact',
        name: 'FACT',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.fact,0)}</span>),
        width:'110px'
    },
    {
        field: 'prod',
        name: 'PROD',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.prod,0)}</span>),
        width:'110px'
    },
    {
        field: 'apor',
        name: 'APOR',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.apor,0)}</span>),
        width:'110px'
    },
    {
        field: 'impsoc',
        name: 'IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.impsoc,0)}</span>),
        width:'110px'
    },
    {
        field: 'bdi',
        name: 'BDI',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.bdi,0)}</span>),
        width:'110px'
    },
    {
        field: 'tasA_IS',
        name: 'TIPO IS',
        sortable: false,
        dataType: 'number',
        render: (data) => (<span>{formaterNumberCell(data.tasA_IS,1)}</span>),
        width:'100px'
    }

  ];